<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
    <div>
        <no-record :condition="doctors" tips='没有找到医生信息'></no-record>
        <ul class="">
            <li @click="onSelectedDoctor(item, index, $event)" v-for="(item, index) in doctors" class="arr-row">
                <div class="doctor-info">
                    <div class="head doc-header" v-bind:style="{backgroundImage: 'url(' +item.avatar+ ')'}">
                    </div>
                    <div class="info">
                        <p class="f-large ellipsis">{{item.rankName}}&nbsp;{{item.doctName}}</p>
                        <p class="f-minor ellipsis" style="margin-top:0.15rem">{{item.deptName}}</p>
                        <p class="f-minor ellipsis" style="margin-top:0.15rem">{{item.doctDesc ? item.doctDesc : '暂无介绍'}}</p>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
    import NoRecord from 'NoRecord';
    import registerService from 'register.service';

    export default {
        components: {
            NoRecord,
        },
        mounted() {
            this.refresh();
        },
        computed:{

        },
        data() {
            return {
                instuteCode: 102,
                doctors: [
//                    {
//                        "doctId": "1001",
//                        "doctName": "崔西玉",
//                        "deptId": "0732",
//                        "deptName": "心血管内科",
//                        "rankId": "721",
//                        "rankName": "主任医生",
//                        "avatar": ""
//                    },
//                    {
//                        "doctId": "1001",
//                        "doctName": "崔西玉",
//                        "deptId": "0732",
//                        "deptName": "心血管内科",
//                        "rankId": "721",
//                        "rankName": "主任医生",
//                        "avatar": ""
//                    }
                ],
            };
        },
        methods: {
            refresh() {
                this.loadDoctorInHos()
            },
            loadDoctorInHos: function() {
                registerService.loadDoctorInHos().then((res) => {
                    if(res.resultCode !== this.constant.RESULT_SUCCESS){
                        this.$utils.alert(res.resultMsg);
                        return;
                    }

                    this.doctors = res.data || [];
                    for (var i = 0; i < this.doctors.length; i++) {
                        if (this.doctors[i].avatar == "" || typeof this.doctors[i].avatar == "undefined") {
                            this.doctors[i].avatar = '../../../static/img/ico-doctor.png'
                        }
                    }
                });
            },
            onSelectedDoctor: function (doctItem) {
                this.$store.commit('updateParam', {
                    namespace: 'doctinfo',
                    selectdoct: doctItem,
                })
                this.$router.push('DoctInfo');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// DoctInfoList.vue?6731cb36